import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Paper,
  Typography,
  Box,
  TextField,
  Button,
  Container,
  CircularProgress,
  ThemeProvider,
  createTheme,
  Autocomplete,
} from "@mui/material";
import { Badge } from "react-bootstrap";
import { useSnackbar } from "notistack";
import apiCall from "../../helpers/api";
import { UPDATE_BANK_DETAILS_API_URL } from "../../configs/url";
import { updateUserInfo } from "../../services/user/actions";
import { useTranslation } from "react-i18next";
import $ from "jquery";

const theme = createTheme({
  palette: {
    primary: {
      main: "#006666",
      light: "#339999",
      dark: "#004c4c",
    },
    background: {
      default: "#b3d9d9",
      paper: "rgba(255, 255, 255, 0.25)",
    },
    text: {
      primary: "#004c4c",
      secondary: "#006666",
    },
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h4: {
      fontWeight: 700,
      background: "linear-gradient(135deg, #006666 0%, #008080 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
    },
  },
});

function BankDetails(props) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    account_number: props?.user?.bank_details?.accountNumber || "",
    bank_name: props?.user?.bank_details?.bankName || "",
    bank_code: props?.user?.bank_details?.bankCode || "",
    account_holder_name: props?.user?.bank_details?.recipientName || "",
    verified: props?.user?.bank_details?.verified || "0",
  });

  useEffect(() => {
    setBankDetails({
      account_number: props?.user?.bank_details?.accountNumber || "",
      bank_name: props?.user?.bank_details?.bankName || "",
      bank_code: props?.user?.bank_details?.bankCode || "",
      account_holder_name: props?.user?.bank_details?.recipientName || "",
      verified: props?.user?.bank_details?.verified || "0",
    });
  }, [props?.user]);

  const bankList = [
    {
      code: "baac",
      name: "Bank for Agriculture and Agricultural Cooperatives",
    },
    {
      code: "bay",
      name: "Bank of Ayudhya (Krungsri)",
    },
    {
      code: "bbl",
      name: "Bangkok Bank",
    },
    {
      code: "bnp",
      name: "BNP Paribas",
    },
    {
      code: "boa",
      name: "Bank of America",
    },
    {
      code: "cacib",
      name: "Crédit Agricole",
    },
    {
      code: "cimb",
      name: "CIMB Thai Bank",
    },
    {
      code: "citi",
      name: "Citibank",
    },
    {
      code: "db",
      name: "Deutsche Bank",
    },
    {
      code: "ghb",
      name: "Government Housing Bank",
    },
    {
      code: "gsb",
      name: "Government Savings Bank",
    },
    {
      code: "hsbc",
      name: "Hongkong and Shanghai Banking Corporation",
    },
    {
      code: "ibank",
      name: "Islamic Bank of Thailand",
    },
    {
      code: "icbc",
      name: "Industrial and Commercial Bank of China (Thai)",
    },
    {
      code: "jpm",
      name: "J.P. Morgan",
    },
    {
      code: "kbank",
      name: "Kasikornbank",
    },
    {
      code: "kk",
      name: "Kiatnakin Bank",
    },
    {
      code: "ktb",
      name: "Krungthai Bank",
    },
    {
      code: "lhb",
      name: "Land and Houses Bank",
    },
    {
      code: "mb",
      name: "Mizuho Bank",
    },
    {
      code: "mega",
      name: "Mega International Commercial Bank",
    },
    {
      code: "mufg",
      name: "Bank of Tokyo-Mitsubishi UFJ",
    },
    {
      code: "rbs",
      name: "Royal Bank of Scotland",
    },
    {
      code: "sc",
      name: "Standard Chartered (Thai)",
    },
    {
      code: "scb",
      name: "Siam Commercial Bank",
    },
    {
      code: "smbc",
      name: "Sumitomo Mitsui Banking Corporation",
    },
    {
      code: "tcrb",
      name: "Thai Credit Retail Bank",
    },
    {
      code: "tisco",
      name: "Tisco Bank",
    },
    {
      code: "ttb",
      name: "TMBThanachart Bank",
    },
    {
      code: "uob",
      name: "United Overseas Bank (Thai)",
    },
  ];

  const handleBankUpdate = () => {
    setLoading(true);
    $("#confirm-button").prop("disabled", true);
    const originalText = $("#confirm-button").text();
    $("#confirm-button").text(t("common_confirming"));
    // Simulate API call
    apiCall({
      url: UPDATE_BANK_DETAILS_API_URL,
      method: "POST",
      data: bankDetails,
    })
      .then((response) => {
        if (response?.data?.success) {
          enqueueSnackbar(t("bank_details_update_success"), {
            variant: "success",
          });
          props?.updateUserInfo();
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.response?.data?.message, { variant: "error" });
      })
      .finally(() => {
        setLoading(false);
        $("#confirm-button").prop("disabled", false);
        $("#confirm-button").text(originalText);
      });
  };

  useEffect(() => {
    if (!props?.user || !props?.user?.auth_token) {
      window.location.href = "/login";
    }
    document.title = "Bank Details | KPG Partner";
  }, []);

  return (
    // <ThemeProvider theme={theme}>
    <Box className="">
      <Container maxWidth="lg">
        <Paper elevation={0} className="glass-card">
          <Box sx={{ mb: 5, textAlign: "center" }}>
            <Typography
              variant="h4"
              component="h1"
              className="bank-details-heading"
              sx={{ mb: 1 }}
            >
              {t("sidebar_bank")}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              className="bank-details-heading"
              sx={{ opacity: 0.8 }}
            >
              {t("bank_details_subtitle")}
            </Typography>
          </Box>

          <Box className="bank-form-grid">
            <TextField
              className="styled-text-field"
              fullWidth
              label={t("bank_details_account_number")}
              variant="outlined"
              value={bankDetails.account_number}
              onChange={(e) =>
                setBankDetails((prevDetails) => ({
                  ...prevDetails,
                  account_number: e.target.value,
                }))
              }
              placeholder={t("bank_details_account_number_input_placeholder")}
            />

            {/* Autocomplete for Bank Name */}
            <Autocomplete
              className="styled-text-field"
              fullWidth
              options={bankList}
              getOptionLabel={(option) => option.name}
              value={
                bankList.find((bank) => bank.code === bankDetails.bank_code) ||
                null
              }
              isOptionEqualToValue={(option, value) =>
                option.code === value.code
              }
              onChange={(event, newValue) => {
                setBankDetails((prevDetails) => ({
                  ...prevDetails,
                  bank_code: newValue ? newValue.code : "",
                  bank_name: newValue ? newValue.name : "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("bank_details_bank_name")}
                  variant="outlined"
                  placeholder={t("bank_details_bank_name_input_placeholder")}
                  readOnly
                />
              )}
            />
            <div>
              <TextField
                className="styled-text-field"
                fullWidth
                label={t("bank_details_account_holder_name")}
                variant="outlined"
                value={bankDetails.account_holder_name}
                onChange={(e) =>
                  setBankDetails((prevDetails) => ({
                    ...prevDetails,
                    account_holder_name: e.target.value,
                  }))
                }
                placeholder={t(
                  "bank_details_account_holder_name_input_placeholder"
                )}
              />
              <small className="text-danger">
                {t("bank_details_account_holder_name_english_input_warning")}
              </small>
            </div>
          </Box>
          <Box
            sx={{ mb: 5 }}
            className="d-flex justify-content-between align-items-center"
          >
            {bankDetails.verified == "0" ? (
              <span variant="body2" className="badge bg-warning">
                {t("common_unverified")}
              </span>
            ) : bankDetails.verified == "1" ? (
              <span variant="body2" className="badge bg-success">
                {t("common_verified")}
              </span>
            ) : bankDetails.verified == "2" ? (
              <span variant="body2" className="badge bg-danger">
                {t("common_failed")}
              </span>
            ) : bankDetails.verified == "3" ? (
              <span variant="body2" className="badge bg-warning">
                {t("common_pending")}
              </span>
            ) : null}
            <button
              className="btn btn-primary"
              onClick={handleBankUpdate}
              id="confirm-button"
            >
              {t("common_confirm")}
            </button>
          </Box>
        </Paper>
      </Container>
    </Box>
    // </ThemeProvider>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = {
  updateUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(BankDetails);
